import PropTypes from "prop-types";
import AlbumDetail from "../album/AlbumDetail"
import { useDrag } from "react-dnd";
import "../../style/DraggableZone.css"

const DraggableZone = ({ album, group, className = `` }) => {  

  const [{isDragging}, drag, dragPreview] = useDrag(() => ({
    type: "album",
    item: album,
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  }), [ album ]);

  return (
      <div className={`draggableZone_div ${isDragging ? "drag" : ``} ${className}`} draggable="true" ref={drag}>
        <AlbumDetail className={`draggableZone_image`} draggable={false} album={album} group={group} showTitle={true} showGroup={true} showCorrectionOnFlip={false}/>
      </div>

  );
};
DraggableZone.propTypes = {
};
export default DraggableZone;
